import React, { useState, useEffect } from 'react';
import "./CriarSolicitacao.css";
import { Form, Select, Button, message, Modal, Input, Table, Space } from 'antd';
import { DownOutlined, UpOutlined, CarOutlined, FileTextOutlined, NumberOutlined } from '@ant-design/icons';
import api from '../../../services/api';
import veiculoService from '../../../services/veiculoService';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import API_CONFIG from '../../../config/api.config';
import { handleApiResponse, handleApiError } from '../../../utils/apiMessages';

const { Option } = Select;

const CriarSolicitacao = () => {
  const [isMenuExpanded, setIsMenuExpanded] = useState(false);
  const [form] = Form.useForm();
  const location = useLocation();
  const navigate = useNavigate();
  const [numeroSolicitacao, setNumeroSolicitacao] = useState(null);
  const [veiculos, setVeiculos] = useState([]);
  const [veiculoSelecionado, setVeiculoSelecionado] = useState(null);
  const [itens, setItens] = useState([]);
  const [modalItemVisivel, setModalItemVisivel] = useState(false);
  const [itemEditando, setItemEditando] = useState(null);
  const [ItemInput, setItemInput] = useState("");
  const [quantidadeInput, setQuantidadeInput] = useState("");
  const [descricaoInput, setDescricaoInput] = useState("");
  const [linhaExpandida, setLinhaExpandida] = useState([]);
  const isMobile = useMediaQuery({ maxWidth: 600 });
  const [loadingCriar, setLoadingCriar] = useState(false);
  const [loadingVeiculos, setLoadingVeiculos] = useState(false);

  // Buscar veículos ao montar
  useEffect(() => {
    const carregarVeiculos = async () => {
      try {
        setLoadingVeiculos(true);
        const idPrefeitura = localStorage.getItem('idPrefeitura');
        const response = await veiculoService.listarPorPrefeitura(idPrefeitura);

        if (response.status && response.veiculos) {
          setVeiculos(response.veiculos);
        } else {
          message.error('Erro ao carregar veículos');
        }
      } catch (error) {
        //console.error('Erro ao carregar veículos:', error);
        message.error('Erro ao carregar veículos');
      } finally {
        setLoadingVeiculos(false);
      }
    };

    carregarVeiculos();
  }, []);

  useEffect(() => {
    const handleMenuChange = (event) => {
      setIsMenuExpanded(!event.detail.isCollapsed);
    };
    window.addEventListener('menuStateChange', handleMenuChange);
    return () => window.removeEventListener('menuStateChange', handleMenuChange);
  }, []);

  // Adicionar ou editar item
  const handleSalvarItem = () => {
    if (!ItemInput.trim()) {
      message.error('Informe o nome do Item.');
      return;
    }
    if (!quantidadeInput.trim()) {
      message.error('Informe a quantidade.');
      return;
    }
    if (itemEditando !== null) {
      // Editar
      const novosItens = [...itens];
      novosItens[itemEditando] = {
        nomeItem: ItemInput,
        quantidade: quantidadeInput,
        descricao: descricaoInput
      };
      setItens(novosItens);
    } else {
      // Adicionar
      setItens([...itens, {
        nomeItem: ItemInput,
        quantidade: quantidadeInput,
        descricao: descricaoInput
      }]);
    }
    setModalItemVisivel(false);
    setItemInput("");
    setQuantidadeInput("");
    setDescricaoInput("");
    setItemEditando(null);
  };

  // Remover item
  const handleRemoverItem = (idx) => {
    setItens(itens.filter((_, i) => i !== idx));
  };

  // Editar item
  const handleEditarItem = (idx) => {
    setItemInput(itens[idx].nomeItem);
    setQuantidadeInput(itens[idx].quantidade);
    setDescricaoInput(itens[idx].descricao || "");
    setItemEditando(idx);
    setModalItemVisivel(true);
  };

  // Adicionar novo item
  const handleAdicionarItem = () => {
    const token = localStorage.getItem('token');
    if (!token) {
      message.error('Sessão expirada. Por favor, faça login novamente.');
      navigate('/');
      return;
    }
    setItemInput("");
    setItemEditando(null);
    setModalItemVisivel(true);
  };

  // Criar solicitação
  const handleCriarSolicitacao = async () => {
    const idPrefeitura = localStorage.getItem('idPrefeitura');
    const idUsuario = localStorage.getItem('idUsuario');
    const token = localStorage.getItem('token');

    if (!token) {
      message.error('Sessão expirada. Por favor, faça login novamente.');
      navigate('/');
      return;
    }

    if (!idPrefeitura || !idUsuario) {
      message.error('Usuário ou prefeitura não encontrados. Faça login novamente.');
      return;
    }

    if (itens.length === 0) {
      message.error('Adicione pelo menos um item.');
      return;
    }

    if (!veiculoSelecionado) {
      message.error('Selecione um veículo.');
      return;
    }

    const payload = {
      SOL_PRE_ID: Number(idPrefeitura),
      SOL_USU_ID: Number(idUsuario),
      SOL_VEI_ID: Number(veiculoSelecionado),
      SOL_DESCRICAO: "",
      itens: itens.map(item => ({
        IT_NOME: item.nomeItem,
        IT_DESCRICAO: item.descricao || "",
        IT_QUANTIDADE: Number(item.quantidade),
        IT_COM_ID: null
      }))
    };

    setLoadingCriar(true);

    try {
      const response = await api.post(API_CONFIG.ENDPOINTS.SOLICITACOES.CADASTRAR, payload);
      const data = response.data;

      if (data.status) {
        message.success({
          content: data.message || 'Solicitação criada com sucesso!',
          duration: 6
        });

        // Limpar todos os campos
        setItens([]);
        setVeiculoSelecionado(null);
        setItemInput("");
        setQuantidadeInput("");
        setDescricaoInput("");
        setItemEditando(null);
        form.resetFields();

        // Desabilitar o botão de criar por 2 segundos para evitar duplicação
        setLoadingCriar(true);
        setTimeout(() => {
          setLoadingCriar(false);
        }, 2000);
      } else {
        message.error(data.message || 'Erro ao criar solicitação.');
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        message.error(error.response.data.message);
      } else {
        message.error('Erro ao conectar com a API.');
      }
    } finally {
      setLoadingCriar(false);
    }
  };


  // Colunas da tabela
  const columns = [
    {
      title: 'Nº',
      dataIndex: 'numero',
      key: 'numero',
      render: (_, __, idx) => idx + 1,
      width: 60
    },
    {
      title: 'Nome do Item',
      dataIndex: 'nomeItem',
      key: 'nomeItem',
    },
    {
      title: 'Quantidade',
      dataIndex: 'quantidade',
      key: 'quantidade',
      width: 120
    },
    {
      title: '',
      key: 'acoes',
      width: 220,
      render: (_, __, idx) => (
        <Space>
          <Button onClick={() => handleEditarItem(idx)}>Editar</Button>
          <Button danger onClick={() => handleRemoverItem(idx)}>Remover</Button>
          <Button
            type="default"
            className="visualizar-btn"
            onClick={() => {
              setLinhaExpandida(linhaExpandida[0] === idx ? [] : [idx]);
            }}
          >
            {linhaExpandida[0] === idx ? 'Fechar' : 'Visualizar'}
          </Button>
        </Space>
      )
    }
  ];

  return (
    <div className={`home-container ${isMenuExpanded ? 'menu-expanded' : ''}`}>
      <div className="modal-wrapper">
        <h1 className="modal-title">Criar Solicitação</h1>
        <div className="modal-content">
          <div className="solicitacao-header-box">
            <div className="solicitacao-header-numero">
              Nº da solicitação: <span style={{ color: '#0070f3' }}>{numeroSolicitacao || '...'}</span>
            </div>
            <div className="solicitacao-header-veiculo">
              <CarOutlined style={{ fontSize: 24, color: '#001f4d' }} />
              <span style={{ fontWeight: 400 }}>Veículo:</span>
              <Select
                className="veiculo-label" style={{ width: '30%' }}
                placeholder="Selecione o veículo"
                value={veiculoSelecionado}
                onChange={setVeiculoSelecionado}
                loading={loadingVeiculos}
                suffixIcon={<DownOutlined style={{ fontSize: 16, color: '#001f4d' }} />}
                dropdownStyle={{
                  borderRadius: '8px',
                  boxShadow: '0 3px 12px rgba(0,0,0,0.1)'
                }}
              >
                {veiculos.map(veiculo => (
                  <Option key={veiculo.VEI_ID} value={veiculo.VEI_ID}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <CarOutlined style={{ fontSize: 16, color: '#001f4d' }} />
                      <div>
                        <span style={{ fontWeight: 500 }}>{veiculo.VEI_DESCRICAO}</span>
                        {' '}
                        <span style={{ fontSize: '0.9em', color: '#666' }}>Placa: {veiculo.VEI_PLACA}</span>
                      </div>
                    </div>
                  </Option>
                ))}
              </Select>
            </div>
          </div>
          <div style={{ textAlign: 'right', marginBottom: 12 }}>
            <Button type="primary" onClick={handleAdicionarItem} className="submit-adicionar" style={{ backgroundColor: '#008026' }}>
              Adicionar Item
            </Button>
          </div>
          {isMobile ? (
            <div className="tabela-mobile">
              {itens.map((item, idx) => (
                <div className="tabela-mobile-item" key={idx}>
                  <div className="item-nome">{item.nomeItem}</div>
                  <div className="item-quantidade">Quantidade: {item.quantidade}</div>
                  <div className="item-botoes">
                    <Button onClick={() => handleEditarItem(idx)} size="small">Editar</Button>
                    <Button danger onClick={() => handleRemoverItem(idx)} size="small">Remover</Button>
                    <Button
                      type="default"
                      className="visualizar-btn"
                      size="small"
                      onClick={() => {
                        setLinhaExpandida(linhaExpandida[0] === idx ? [] : [idx]);
                      }}
                    >
                      {linhaExpandida[0] === idx ? 'Fechar' : 'Visualizar'}
                    </Button>
                  </div>
                  {linhaExpandida[0] === idx && (
                    <>
                      {item.descricao && (
                        <div className="item-descricao">{item.descricao}</div>
                      )}
                      <div className="detalhe-expandido-item" style={{ marginTop: 8 }}>
                        <div className="col-esq">
                          <div>
                            <span className="label-icone"><FileTextOutlined /> Nome do item:</span>
                            <div className="valor-destaque">{item.nomeItem}</div>
                          </div>
                          <div>
                            <span className="label-icone"><NumberOutlined /> Quantidade:</span>
                            <div className="valor-destaque">{item.quantidade}</div>
                          </div>
                        </div>
                        <div className="col-dir">
                          <span className="label-icone"><FileTextOutlined /> Descrição:</span>
                          <div className="descricao-expandida">{item.descricao || '-'}</div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <Table
              columns={columns}
              dataSource={itens}
              pagination={false}
              rowKey={(_, idx) => idx}
              style={{ background: 'white', marginBottom: 24, clear: 'both' }}
              className="tabela-solicitacao"
              expandable={{
                expandedRowRender: (record) => (
                  <div className="detalhe-expandido-item">
                    <div className="col-esq">
                      <div>
                        <span className="label-icone"><FileTextOutlined /> Nome do item:</span>
                        <div className="valor-destaque">{record.nomeItem}</div>
                      </div>
                      <div>
                        <span className="label-icone"><NumberOutlined /> Quantidade:</span>
                        <div className="valor-destaque">{record.quantidade}</div>
                      </div>
                    </div>
                    <div className="col-dir">
                      <span className="label-icone"><FileTextOutlined /> Descrição:</span>
                      <div className="descricao-expandida">{record.descricao || '-'}</div>
                    </div>
                  </div>
                ),
                expandedRowKeys: linhaExpandida,
                onExpand: (expanded, record, index) => {
                  // Não faz nada aqui, pois o controle é feito pelo botão Visualizar
                },
                showExpandColumn: false
              }}
            />
          )}
          <div style={{ textAlign: 'right', marginTop: 24 }}>
            <Button
              type="primary"
              onClick={handleCriarSolicitacao}
              className="submit-button"
              loading={loadingCriar}
            >
              Criar
            </Button>
          </div>
        </div>
        <Modal
           title={itemEditando !== null ? 'Editar Item' : 'Adicionar Item'}
           open={modalItemVisivel}
           onCancel={() => {
             setModalItemVisivel(false);
             setItemEditando(null);
             setItemInput("");
             setQuantidadeInput("");
             setDescricaoInput("");
           }}
           centered
           maskClosable={false}
           destroyOnClose
           wrapClassName={isMobile ? "modal-mobile-fullscreen" : ""}
           footer={
             <div className="modal-buttons-pre">
               <Button
                 danger
                 onClick={() => {
                   setModalItemVisivel(false);
                   setItemEditando(null);
                   setItemInput("");
                   setQuantidadeInput("");
                   setDescricaoInput("");
                 }}
                 style={{
                   background: '#fff',
                   color: '#d32f2f',
                   border: '1.5px solid #d32f2f',
                   height: 48,
                   fontSize: '1.15rem',
                   minWidth: 120
                 }}
               >
                 Cancelar
               </Button>
               <Button
                 type="primary"
                 onClick={handleSalvarItem}
                 style={{
                   background: 'linear-gradient(90deg, #001f4d 60%, #003380 100%)',
                   color: '#fff',
                   border: 'none',
                   height: 48,
                   fontSize: '1.15rem',
                   minWidth: 120
                 }}
               >
                 Salvar
               </Button>
             </div>
           }
         
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Nome do Item *</label>
              <Input
                placeholder="Nome do Item"
                value={ItemInput}
                onChange={e => setItemInput(e.target.value)}
                maxLength={100}
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Quantidade/Litros *</label>
              <Input
                placeholder="Quantidade/Litros"
                value={quantidadeInput}
                onChange={e => setQuantidadeInput(e.target.value)}
                type="number"
                min="1"
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Descrição</label>
              <Input.TextArea
                placeholder="Descrição do item"
                value={descricaoInput}
                onChange={e => setDescricaoInput(e.target.value)}
                maxLength={500}
                rows={4}
              />
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default CriarSolicitacao;